<template>
  <div class="DList inner_center">
    <div
      v-for="(vo,idx) in list"
      :key="idx"
    >
      <DListHeader
        :item="vo"
        :idx="idx"
        class="DListHeader"
        v-on="$listeners"
      />
      <PicList
        :pic-list="vo.pictures"
        class="PicList" />
    </div>
  </div>
</template>

<script>
import DListHeader from '@/components/3d/d-list/d-list-header'
import PicList from '@/components/pic/pic-list/pic-list';

export default {
  name: "DList",
  components:{
    DListHeader,
    PicList
  },
  props:{
    list:{
      type: Array,
      default:()=>[]
    }
  }
}
</script>

<style lang="scss" scoped>
.DList{

  .DListHeader{
    margin-bottom: 32px;
  }
  .PicList{
    margin-bottom: 32px;
  }
}
</style>
